import objectAssign from 'object-assign';
import { Link } from 'react-router';
import pagination from '../../search/paginate';
import React from 'react';

import './pagination.scss';

class Pagination extends React.Component {
  handleChange(pageNumber) {
    this.props.changeFilter('activePage', pageNumber);
    if (document) {
      document.getElementById('results-title').scrollIntoView();
    }
  }

  render() {
    const pages = pagination
      .paginate({
        count: this.props.count,
        pageSize: this.props.pageSize,
        activePage: this.props.activePage,
        includePrevNext: true
      })
      .map(function (page, index) {
        if (page.isEllipses) {
          return <span key={index}>{page.linkText}</span>;
        }
        const ariaProps = page.isCurrentPage ? { 'aria-current': 'page' } : {};
        return (
          <Link
            to={{
              pathname: this.props.location.pathname,
              query: objectAssign({}, this.props.location.query, {page: page.pageNumber})
            }}
            className={page.selectedClass}
            title={page.titleText}
            key={index}
            onClick={this.handleChange.bind(this, page.pageNumber)}
            aria-label={page.titleText}
            {...ariaProps}
            >{page.linkText}</Link>
        );
      }.bind(this));
    return (
      <div className="small-pager">
        <nav aria-label="page">
          {pages}
        </nav>
      </div>
    );
  }
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/search/pagination/index.js